import {FETCH_CUSTOM_FOOTER_FULFILLED} from "../actions/getCustomFooter";

export interface FooterTemplateContent {
  versionId: string;
  contentId: string;
  url: string;
  name: string;
}

export interface FooterLinkType {
  id: string;
  name: string;
  url: string;
}

export default function (state: FooterLinkType[] | null = null, action: any) : FooterLinkType[] | null {
  switch (action.type) {
    case FETCH_CUSTOM_FOOTER_FULFILLED: {
      if(action.payload.data){
       return action.payload.data.map((footerContent : FooterTemplateContent)=>
           {return {...footerContent, id: footerContent.contentId};}
       )
      }
      return state;
    }
    default:
      return state;
  }
}
